export default {
  hasMediaFile: (state) => (type) => {
    const configurations = state.configurations
    let path

    if (!configurations || configurations.length === 0) return false

    switch (type) {
      case 'introduction':
        path = 'introductionVideoUrl'
        break
      case 'conclusion':
        path = 'conclusionVideoUrl'
        break
      case 'audio':
        path = 'audioUrl'
        break
      default:
        return false
    }

    return configurations[0] && !!configurations[0][path]
  },

  mediaFileUrl: (state) => (indexName) => {
    const configurations = state.configurations
    if (!configurations || configurations.length === 0) return false

    if (indexName === 'introduction') return configurations[0].introductionVideoUrl
    if (indexName === 'conclusion') return configurations[0].conclusionVideoUrl
    if (indexName === 'audio') return configurations[0].audioUrl
  }
}
